export enum TestResultRunStatus {
    Current = 1,
    Superseded = 2,
}
